import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm space-y-5">
        <h1 className="font-heading text-2xl font-bold text-slate-900">Lupa Kata Sandi</h1>
        {sent ? (
          <p className="text-sm text-slate-600" data-testid="forgot-sent">
            Jika email terdaftar, tautan atur ulang kata sandi telah dikirim. Silakan periksa kotak masuk Anda.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} data-testid="forgot-email"
                onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <Button type="submit" className="w-full bg-blue-800 hover:bg-blue-900" data-testid="forgot-submit">
              Kirim Tautan
            </Button>
          </form>
        )}
        <Link to="/login" className="block text-center text-sm text-blue-700 hover:underline">
          Kembali ke halaman masuk
        </Link>
      </div>
    </div>
  );
}
